// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 763 ? "classification" : chunkId) + "." + {"471":"fd2732e4","656":"6be36264","763":"a1c8d2fd","788":"ee867130","793":"4a8db486","813":"43eb461e","889":"6b5803ee","940":"d5cde5ad"}[chunkId] + ".css";
};